import React from 'react';
import { KatNavigation } from '@amzn/katal-react';
import Link from 'next/link';

export interface PageNavigationProps {
  name: string;
  links: Array<LinkElementProps>;
}

export interface LinkElementProps {
  isSelected: boolean;
  href: string;
  label: React.ReactNode;
  onClick?: () => void;
}

const PageNavigation: React.FC<PageNavigationProps> = ({
  name,
  links,
}) => (
  <KatNavigation mode="horizontal">
    <span slot="label">{name}</span>
    {links.map((link) => (
      <Link
        prefetch={false}
        key={link.href}
        href={link.href}
        onClick={link.onClick}
        {...(link.isSelected ? { 'data-active': true } : {})}
      >
        {link.label}
      </Link>
    ))}
  </KatNavigation>
);

export default PageNavigation;
